module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return _c('div', [_c('h1', {
    staticClass: "text-center"
  }, [_vm._v("Repos")]), _vm._v(" "), _c('h4', {
    staticClass: "text-center"
  }, [_vm._v("Github Repos")]), _vm._v(" "), _c('section', {
    staticClass: "content"
  }, [_c('div', {
    staticClass: "row"
  }, [(_vm.error) ? _c('div', [_vm._v("\n        Found an error\n      ")]) : _c('div', _vm._l((_vm.response), function(repo) {
    return (_vm.response) ? _c('div', {
      staticClass: "col-md-4"
    }, [_c('div', {
      staticClass: "box box-widget widget-user"
    }, [_c('div', {
      staticClass: "widget-user-header bg-aqua-active text-center"
    }, [_c('h3', {
      staticClass: "widget-user-username center-text"
    }, [_vm._v(_vm._s(repo.name))])]), _vm._v(" "), _c('div', {
      staticClass: "widget-user-image"
    }, [_c('img', {
      staticClass: "img-circle",
      attrs: {
        "src": repo.owner.avatar_url,
        "alt": "repo.owner.login + ' Avatar'"
      }
    })]), _vm._v(" "), _c('div', {
      staticClass: "box-footer"
    }, [_c('div', {
      staticClass: "row"
    }, [_c('div', {
      staticClass: "col-sm-4 border-right"
    }, [_c('div', {
      staticClass: "description-block"
    }, [_c('h5', {
      staticClass: "description-header"
    }, [_vm._v(_vm._s(repo.stargazers_count))]), _vm._v(" "), _c('span', {
      staticClass: "description-text"
    }, [_vm._v("Star")])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4 border-right"
    }, [_c('div', {
      staticClass: "description-block"
    }, [_c('a', {
      attrs: {
        "href": repo.owner.html_url,
        "target": "_blank"
      }
    }, [_c('button', {
      staticClass: "btn btn-default btn-lg",
      attrs: {
        "type": "button"
      }
    }, [_vm._v("Visit")])])])]), _vm._v(" "), _c('div', {
      staticClass: "col-sm-4"
    }, [_c('div', {
      staticClass: "description-block"
    }, [_c('h5', {
      staticClass: "description-header"
    }, [_vm._v(_vm._s(repo.forks_count))]), _vm._v(" "), _c('span', {
      staticClass: "description-text"
    }, [_vm._v("Forks")])])])])])])]) : _vm._e()
  }))])])])
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-c073e18c"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/views/Repos.vue
// module id = 1279
// module chunks = 1